import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  title = 'Todo Sector - Software a medida';
  description =
    'Todo Sector ofrece soluciones de software innovadoras y personalizadas para tu negocio. Descubre nuestras herramientas hoy mismo.';

  layoutMode = 'overlay';

  darkMenu = false;

  isRTL = false;

  business = {
    name: 'Todo Sector - Software a medida',
    fiscal_name: 'Todo Sector Digital S.L.',
    cif: 'B25970112',
    telephone: '+34 674 593 441',
    mobile: '',
    email: 'info@todosector.com',
    address: 'C/ Fluvià 1 Derecha Bajos',
    cp: '07009',
    city: 'Palma',
    province: 'Islas Baleares',
    country: 'España',
  };

  domain = 'https://todosector.com';

  yearChanges = '2026';

  scrollToSection(sectionId: string, route: string): void {
    const currentUrl = this.router.url.split('#')[0];

    if (currentUrl === route) {
      // Ya estamos en la ruta, solo scroll
      setTimeout(() => {
        if (isPlatformBrowser(this.platformId)) {
          const element = document.getElementById(sectionId);
          if (element) {
            const elementPosition =
              element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: elementPosition, behavior: 'smooth' });
          }
        }
      }, 50);
    } else {
      // Navega y luego scroll
      this.router.navigate([route], { fragment: sectionId }).then(() => {
        setTimeout(() => {
          if (isPlatformBrowser(this.platformId)) {
            const element = document.getElementById(sectionId);
            if (element) {
              const elementPosition =
                element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({ top: elementPosition, behavior: 'smooth' });
            }
          }
        }, 200); // Da tiempo a que cargue el DOM
      });
    }
  }
}
